import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PreferencesState {
  showHelp: boolean;
}

// Charger les préférences depuis localStorage
const loadPreferences = (): PreferencesState => {
  const saved = localStorage.getItem('userPreferences');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      return {
        showHelp: parsed.showHelp !== undefined ? parsed.showHelp : true, // Par défaut, l'aide est affichée
      };
    } catch (e) {
      console.error('Error loading preferences:', e);
    }
  }
  // Valeurs par défaut
  return {
    showHelp: true, // Par défaut, l'aide est affichée
  };
};

const initialState: PreferencesState = loadPreferences();

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setShowHelp: (state, action: PayloadAction<boolean>) => {
      state.showHelp = action.payload;
      // Persister dans localStorage
      localStorage.setItem('userPreferences', JSON.stringify({
        showHelp: state.showHelp,
      }));
    },
    toggleShowHelp: (state) => {
      state.showHelp = !state.showHelp;
      // Persister dans localStorage
      localStorage.setItem('userPreferences', JSON.stringify({
        showHelp: state.showHelp,
      }));
    },
  },
});

export const { setShowHelp, toggleShowHelp } = preferencesSlice.actions;
export default preferencesSlice.reducer;

